export default __webpack_public_path__ + "static/media/logo.4cb45ff9.png";